import { Component, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../shared/base-components/base.component';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerPlateModel } from '../../titleregistration/models/customer-plate.model';
import { PlateStatusType } from '../../titleregistration/models/enums/plate-status-type.enum';
import { PlateType } from '../../titleregistration/models/enums/plate-type.enum';
import { PlateService } from '../../titleregistration/services/plate.service';
import { HistoricalCustomerPlacardModalComponent, HistoricalPlacardContext } from './historical-customer-placard-modal.component';

@Component({
    selector: 'customer-placard',
    templateUrl: './customer-placard.html',
    inputs: ['customerNumber', 'placards'],
    outputs: ['acpChanged']
})

export class CustomerPlacardComponent extends BaseComponent {
    public placards: CustomerPlateModel[];
    public placardDisplayInfo: any[];
    public customerNumber: number;
    public placardTypes: PlateType = new PlateType();
    public statusTypes: PlateStatusType = new PlateStatusType();
    public acpChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        public modalService: MvdModalService,
        private placardService: PlateService) {
        super();
    }

    ngOnInit() {
        if (this.placards !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateCharacteristics(this.customerNumber);
        }
    }

    populateCharacteristics(customerNumberId: number) {
        this.placardService.getPlacardsByCustomerNumber(customerNumberId)
            .subscribe(result => {
                this.placards = result;
            },
            e => console.log('error', e),
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        this.placardDisplayInfo = [];
        for (let placard of this.placards) {
            this.placardDisplayInfo.push({
                placardNumber: placard.plate.plateNumber,
                placardType: this.getPlateType(placard.plate.plateConfiguration.plateTypeId),
                placardIssueDate: placard.issueDate,
                placardExpirationDate: placard.expiredDate,
                placardStatus: this.getStatus(placard.plate.plateStatusTypeId),
                placardStatusChangeDate: placard.plate.plateStatusChangeDate
            });
        }
    }

    getStatus(statusId: number): string {
        let displayValue = this.statusTypes.FromId(statusId).displayValue;
        if (null == displayValue) {
            throw `Template type ${statusId} is missing.`;
        }
        return displayValue;
    }

    getPlateType(plateTypeId: number) {
        let displayValue = this.placardTypes.FromId(plateTypeId).displayValue;
        if (null == displayValue) {
            throw `Template type ${plateTypeId} is missing.`;
        }
        return displayValue;
    }

    showHistory() {
        const data = new HistoricalPlacardContext(this.customerNumber);
        this.modalService.open(HistoricalCustomerPlacardModalComponent, data);
    }
}
